import type { Action } from 'redux';
import { TIKTOK_SAN_MACHINE_NAME } from '../../../../../../../shared/constants';
import dash_api from '../../../../../main/support/dash_api';
import type { Advertiser } from '../../../../../main/types/adPartnerTypes';
import { ReduxAsyncAction } from '../../../../services/ReduxAsyncAction';
import type { TikTokSANAdvertisersPayload } from '../TikTokSAN.types';

const GetTikTokSANAdvertisers = new ReduxAsyncAction<'GET_TIKTOK_SAN_ADVERTISERS', void, TikTokSANAdvertisersPayload>(
  'GET_TIKTOK_SAN_ADVERTISERS'
);
GetTikTokSANAdvertisers.registerRequest(async () => {
  const { data }: { data: Advertiser[] } = await dash_api.get(
    `/v1/tiktok/advertisers?machine_name=${TIKTOK_SAN_MACHINE_NAME}`
  );
  return {
    advertisers: data,
  };
});
export const GET_TIKTOK_SAN_ADVERTISERS = GetTikTokSANAdvertisers.actionNamespaceConstants;
export const getTikTokSANAdvertisers = GetTikTokSANAdvertisers.request;

export type GetTikTokSANAdvertisersAction = Action<
  typeof GET_TIKTOK_SAN_ADVERTISERS.response | typeof GET_TIKTOK_SAN_ADVERTISERS.request
> & {
  data: TikTokSANAdvertisersPayload;
};
